import React, { Component } from 'react';
import { connect } from "react-redux";
import axios from 'axios';
import { clickedNodeAction } from "../../../actions/clickedNodeActions";
import PanelLayout from "../components/PanelLayout";
import ContentWithTopLabel from "../components/ContentWithTopLabel";
import axiosConfig from "../../../utils/axiosConfig";
import messageCodes from "../../../utils/messageCodes";
import { showToastForBackend, showToastForFrontend } from "../../../actions/toastActions";
import MaterialIcon from '../../MaterialIcon';
import SelectBox from "../components/SelectBox";
import InputWithLabel from "../components/InputWithLabel";
import ToggleableContent from "../components/ToggleableContent";
import ValueTypeSelector from "../components/ValueTypeSelector";

class GroupByPropertyPanel extends Component {

    constructor(props) {
        super(props);

        this.predictionOptions = [
            {
                label: "Previous Prediction",
                value: "previousPrediction"
            },
            {
                label: "Sum of top N",
                value: "sumOfTopN"
            },
            {
                label: "Average of top N",
                value: "averageOfTopN"
            }
        ];
        this.selectOptions = [
            {
                label: "Top",
                value: "top"
            },
            {
                label: "Random",
                value: "random"
            }
        ];
        this.types = [
            {
                text: "Constant Value",
                xmlType: "constantValue"
            },
            {
                text: "Context Property",
                xmlType: "contextProperty"
            }
        ]

        this.hasOptions = this.props.clickedNodeInfo.extras.options && this.props.clickedNodeInfo.extras.options.groupByOptions;


        this.defaultContextProperty = this.props.contextProps ? this.props.contextProps[0].name : null;
        this.defaultMaxItemsByGroup = {
            isSelected: false,
            selectedType: "constantValue",
            constantValue: "1",
            contextProperty: this.defaultContextProperty
        }

        this.state = {
            allItemProperties: [],
            itemProperties: this.hasOptions && this.hasOptions.itemProperties   ? this.props.clickedNodeInfo.extras.options.groupByOptions.itemProperties : [],
            dynPropInput: this.hasOptions ? this.props.clickedNodeInfo.extras.options.groupByOptions.dynPropInput : "",
            dynamicProperties: this.hasOptions && this.hasOptions.dynamicProperties ? this.props.clickedNodeInfo.extras.options.groupByOptions.dynamicProperties : [],
            showError: false,
            predictionComputation: this.hasOptions ? this.props.clickedNodeInfo.extras.options.groupByOptions.predictionComputation : this.predictionOptions[0].value,
            topN: this.hasOptions ? this.props.clickedNodeInfo.extras.options.groupByOptions.topN : "",
            selectType: this.hasOptions ? this.props.clickedNodeInfo.extras.options.groupByOptions.selectType : null,
            maxItemsByGroup: this.hasOptions ? this.props.clickedNodeInfo.extras.options.groupByOptions.maxItemsByGroup?.isSelected ?
                this.props.clickedNodeInfo.extras.options.groupByOptions.maxItemsByGroup :
                this.defaultMaxItemsByGroup : this.defaultMaxItemsByGroup,
            inputScoreDynamicPropertyName: this.hasOptions ? this.props.clickedNodeInfo.extras.options.groupByOptions.inputScoreDynamicPropertyName : "",
            outputScoreDynamicPropertyName: this.hasOptions ? this.props.clickedNodeInfo.extras.options.groupByOptions.outputScoreDynamicPropertyName : "",
        };

        this.getItemProperties = this.getItemProperties.bind(this);
        this.handleItemPropertySelect = this.handleItemPropertySelect.bind(this);
        this.onDeleteSelectedItemProperty = this.onDeleteSelectedItemProperty.bind(this);
        this.handleDynamicPropertyEnter = this.handleDynamicPropertyEnter.bind(this);
        this.onDynamicPropertyInputChange = this.onDynamicPropertyInputChange.bind(this);
        this.onDeleteDynamicProperty = this.onDeleteDynamicProperty.bind(this);
        this.onSelectToggle = this.onSelectToggle.bind(this);
        this.onMaxByGroupToggle = this.onMaxByGroupToggle.bind(this);
        this.onPropertyChange = this.onPropertyChange.bind(this);
        this.onTypeChange = this.onTypeChange.bind(this);
        this.onContextPropertyChange = this.onContextPropertyChange.bind(this);
        this.onConstantValueChange = this.onConstantValueChange.bind(this);
    }

    componentDidMount() {
        this.getItemProperties();
        this.updateOptions();
    }

    componentDidUpdate(prevProps, prevState) {
        const shouldUpdateOptions =
            (prevState.itemProperties?.length !== this.state.itemProperties?.length)
            || (prevState.dynamicProperties?.length !== this.state.dynamicProperties?.length)
            || (prevState.predictionComputation !== this.state.predictionComputation)
            || (prevState.topN !== this.state.topN)
            || (prevState.selectType !== this.state.selectType)
            || (prevState.inputScoreDynamicPropertyName !== this.state.inputScoreDynamicPropertyName)
            || (prevState.outputScoreDynamicPropertyName !== this.state.outputScoreDynamicPropertyName)
            || (prevState.maxItemsByGroup !== this.state.maxItemsByGroup);

        if (shouldUpdateOptions)
            this.updateOptions();
    }

    updateOptions() {
        const clickedNodeInfo = this.props.clickedNodeInfo;
        let groupByOptions = Object.assign({}, clickedNodeInfo);
        if (!Object.prototype.hasOwnProperty.call(groupByOptions.extras, "options")) {
            groupByOptions.extras.options = {};
        }
        groupByOptions.extras.options = {
            ...groupByOptions.extras.options,
            groupByOptions: {
                itemProperties: this.state.itemProperties ? this.state.itemProperties : [],
                dynamicProperties: this.state.dynamicProperties ? this.state.dynamicProperties : [],
                predictionComputation: this.state.predictionComputation,
                topN: this.state.topN ? this.state.topN : "",
                selectType: this.state.selectType,
                maxItemsByGroup: this.state.maxItemsByGroup,
                inputScoreDynamicPropertyName: this.state.inputScoreDynamicPropertyName ? this.state.inputScoreDynamicPropertyName : "",
                outputScoreDynamicPropertyName: this.state.outputScoreDynamicPropertyName ? this.state.outputScoreDynamicPropertyName : "",
            }
        };

        this.props.clickedNodeAction(groupByOptions);
    }

    getItemProperties() {
        axios.get(this.props.properties.databaseUrl + "/properties/items", axiosConfig())
            .then(response => {

                // Filter already selected ones
                let allItemProperties = response.data;
                if (this.state.itemProperties) {
                    allItemProperties.filter(prop => !this.state.itemProperties.includes(prop));
                }
                allItemProperties.sort();
                allItemProperties = allItemProperties.map(value => ({label: value, value}));
                this.setState({
                    allItemProperties
                });
            })
            .catch(err => {
                if (err.response)
                    this.props.showToastForBackend(err.response.data);
                else
                    this.props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
            })
    }

    handleItemPropertySelect(e) {
        const itemProperty = e.target.value;
        const allItemProperties = this.state.allItemProperties.filter(prop => prop.value !== itemProperty);

        this.setState(prevState => ({
            allItemProperties,
            itemProperties: [
                ...prevState.itemProperties,
                itemProperty
            ]
        }))
    }

    onDeleteSelectedItemProperty(name) {
        const itemProperty = this.state.itemProperties.find(value => value === name);
        let itemProperties = this.state.itemProperties.filter((value) => (value !== name));

        let allItemProperties = [...this.state.allItemProperties, {label: itemProperty, value: itemProperty}];
        allItemProperties.sort((a, b) => a.value > b.value);

        this.setState({
            itemProperties, allItemProperties
        });
    }

    handleDynamicPropertyEnter(e) {
        e.preventDefault();

        const newDynProp = this.state.dynPropInput;

        // Input validation for duplicate props
        if (this.state.dynamicProperties.includes(newDynProp) || this.state.dynPropInput === "") {
            this.setState({showError: true});
        } else {
            this.setState(prevState => ({
                dynamicProperties: [
                    ...prevState.dynamicProperties,
                    newDynProp,
                ],
                showError: false,
                dynPropInput: ""
            }));
        }
    }

    onDynamicPropertyInputChange(e) {
        this.setState({
            dynPropInput: e.target.value,
            showError: false
        })
    }

    onDeleteDynamicProperty(name) {
        const dynamicProperties = this.state.dynamicProperties.filter(value => value !== name);
        this.setState({dynamicProperties});
    }

    onPropertyChange(property, e) {
        const value = e.target.value;

        this.setState({
            [property]: value
        })
    }

    onTypeChange(text) {
        let selected = this.types.find((type) => type.text === text);
        const maxItemsByGroup = {...this.state.maxItemsByGroup};
        maxItemsByGroup.selectedType = selected.xmlType;
        this.setState({maxItemsByGroup});
    }

    onContextPropertyChange(e) {
        const value = e.target.value;
        const maxItemsByGroup = {...this.state.maxItemsByGroup};
        maxItemsByGroup.contextProperty = value;
        this.setState({maxItemsByGroup})
    }

    onSelectToggle() {
        if (this.state.selectType) {
            this.setState({selectType: null});
        } else {
            this.setState({selectType: this.selectOptions[0].value});
        }
    }

    onConstantValueChange(e) {
        const value = e.target.value;
        const maxItemsByGroup = {...this.state.maxItemsByGroup};
        maxItemsByGroup.constantValue = value;
        this.setState({maxItemsByGroup});
    }


    onMaxByGroupToggle() {
        const maxItemsByGroup = {...this.state.maxItemsByGroup};
        maxItemsByGroup.isSelected = !this.state.maxItemsByGroup.isSelected
        this.setState({maxItemsByGroup});
        // if (this.state.maxItemsByGroup) {
        //     this.setState({maxItemsByGroup: null});
        // } else {
        //     this.setState({maxItemsByGroup: 1});
        // }
    }

    render() {
        return (
            <PanelLayout>
                <ContentWithTopLabel label="Properties">
                    <div className="property-select filter-rule">
                        <span className="label">Item properties</span>
                        <SelectBox showDefault selectValue={""} handleChangeSelect={this.handleItemPropertySelect}
                                   selectArray={this.state.allItemProperties}/>
                        <div className="selected-property-list">
                            {this.state.itemProperties?.map((selectedProp) => (
                                <span key={selectedProp} className="selected-property">
                                    {selectedProp} <MaterialIcon
                                    onClick={() => this.onDeleteSelectedItemProperty(selectedProp)} icon="close"/>
                                </span>
                            ))}
                        </div>
                    </div>

                    <div className="property-select filter-rule">
                        <form className="add-dyn-property" onSubmit={this.handleDynamicPropertyEnter}>
                            <InputWithLabel showError={this.state.showError} label="Dynamic Property"
                                            value={this.state.dynPropInput}
                                            handleChange={this.onDynamicPropertyInputChange}/>
                            <button className="add-button" type="submit"><MaterialIcon icon="add_circle"/></button>
                        </form>
                        <div className="selected-property-list">
                            {this.state.dynamicProperties?.map((selectedProp) => (
                                <span key={selectedProp} className="selected-property">
                                    {selectedProp} <MaterialIcon
                                    onClick={() => this.onDeleteDynamicProperty(selectedProp)} icon="close"/>
                                </span>
                            ))}
                        </div>
                    </div>
                </ContentWithTopLabel>
                <ContentWithTopLabel label="Prediction">
                    <div className="filter-rule">
                        <SelectBox selectArray={this.predictionOptions} selectValue={this.state.predictionComputation}
                                   handleChangeSelect={e => this.onPropertyChange("predictionComputation", e)}/>
                        {["averageOfTopN", "sumOfTopN"].includes(this.state.predictionComputation) && (
                            <InputWithLabel value={this.state.topN}
                                            handleChange={e => this.onPropertyChange("topN", e)}/>
                        )}
                    </div>
                </ContentWithTopLabel>
                <ToggleableContent label={"Select"} isSelected={!!this.state.selectType} onToggle={this.onSelectToggle}>
                    <div className="filter-rule">
                        <SelectBox selectArray={this.selectOptions} selectValue={this.state.selectType}
                                   handleChangeSelect={e => this.onPropertyChange("selectType", e)}/>
                    </div>
                </ToggleableContent>
                <ToggleableContent label={"Maximum items by group"} isSelected={this.state.maxItemsByGroup?.isSelected}
                                   onToggle={this.onMaxByGroupToggle}>
                    {/*<div className="filter-rule">*/}
                    {/*<InputWithLabel value={this.state.maxItemsByGroup} handleChange={this.handleMaxByGroupChange}*/}
                    {/*                type="number"/>*/}
                    <ValueTypeSelector types={this.types}
                                       disableArea={false}
                                       selectedType={this.state.maxItemsByGroup?.selectedType}
                                       onTypeSelect={(index) => this.onTypeChange(index)}/>
                    {this.state.maxItemsByGroup?.selectedType === "constantValue" && (
                        <input type="number" defaultValue={this.state.maxItemsByGroup?.constantValue}
                               onBlur={(e) => this.onConstantValueChange(e)}/>
                    )}
                    {this.state.maxItemsByGroup?.selectedType === "contextProperty" && (
                        <select onChange={(e) => this.onContextPropertyChange(e)}
                                value={this.state.maxItemsByGroup?.contextProperty}>
                            <option className="select-placeholder" value="" disabled defaultValue>Please select an
                                option
                            </option>
                            {this.props.contextProps && this.props.contextProps.sort(
                                (a, b) => a.name > b.name ? 1 : -1
                            ).map((contextProp) => (
                                <option key={contextProp.name}>{contextProp.name}</option>
                            ))}
                        </select>
                    )}
                    {/*</div>*/}
                    {/*<button onClick={() => console.log("maxItemsByGroup", this.state.maxItemsByGroup)}>maxItemsByGroup</button>*/}
                </ToggleableContent>
                <ContentWithTopLabel label="Input Score Name">
                    <InputWithLabel label="Input Score Dynamic Property Name:"
                                    handleChange={e => this.onPropertyChange('inputScoreDynamicPropertyName', e)}
                                    value={this.state.inputScoreDynamicPropertyName}
                    />
                </ContentWithTopLabel>
                <ContentWithTopLabel label="Output Score Name">
                    <InputWithLabel label="Output Score Dynamic Property Name:"
                                    handleChange={e => this.onPropertyChange('outputScoreDynamicPropertyName', e)}
                                    value={this.state.outputScoreDynamicPropertyName}
                    />
                </ContentWithTopLabel>
            </PanelLayout>
        );
    }
}

function mapStateToProps(state) {
    return {
        clickedNodeInfo: state.clickedNodeInfo,
        contextProps: state.contextProperties,
        properties: state.properties
    }
}

export default connect(mapStateToProps, {
    clickedNodeAction,
    showToastForFrontend,
    showToastForBackend
})(GroupByPropertyPanel);
